export default {
  url: 'https://neo.ppa-online.cz/api',
  locale: 'cz',
}
